module.exports={
    logout  : "закрыть счёт",
    my      :' мой ',
    scqx    :' Удалить права ',
    qxgl    :'Управление правами ',
    qdzxzhm :'Ты уверен, что списываешь номер счета?',
    qtxkh   :' Заполните, пожалуйста, номер карточки ',
    qd      :'определение ',
    qx      :'отмена',
    gb      :'закрыть ',
    kh      :'номер кадра',
    kmewm   :'открытый двухмерный код',
    dl      :'вход ',
    name    :'Имя пользователя',
    qtxname :' Введите имя пользователя',
    pwas    :'пароль ',
    qtxpwas :'Введите пароль',
    tj      :'представление',
    zczh    :' регистрационный номер счета ',
    zc      :'регистрация',
    sjhm    :' номер телефона',
    qtxsjhm :' Заполните, пожалуйста, номер телефона.',
    yzm     :'код проверки ',
    qtxyzm  :'Заполните код проверки',
    yyzhqqdl:'номер счёта, вход ',
    hqyzm   :'получение кода проверки',
    zccg    :'регистрация прошла успешно',
    zcsb    :'Ошибка регистрации',
    fscg    :'отправка завершена',
    fssb    :'Ошибка отправки ',
    yhycz   :' пользователь уже существует'
}